// extracted by mini-css-extract-plugin
export default {"departments":"rH-z","departmentHeading":"sH-z","departmentSection":"tH-z","departmentName":"uH-z","departmentLink":"vH-z","expandIcon":"wH-z"};